var _defs, _clipPath, _g, _path, _g2, _path2, _g3, _g4, _g5, _radialGradient, _path3, _g6, _radialGradient2, _path4, _radialGradient3, _path5, _g7, _g8, _g9, _radialGradient4, _circle, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChromeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 96,
    cy: 96,
    r: 88
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 29.337,
    y1: 75.021,
    x2: 81.837,
    y2: 44.354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#3E2723",
    fillOpacity: 0.15,
    d: "M62.31 115.65L22.48 47.34l-.58 1 39.54 67.8z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 110.872,
    y1: 164.495,
    x2: 52.538,
    y2: 130.329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "#263238",
    fillOpacity: 0.15,
    d: "M129.84 117.33l-.83-.48L90.62 184h1.15l38.1-66.64z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 121.858,
    y1: 49.804,
    x2: 136.547,
    y2: 114.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD40",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 121.858,
    y1: 49.804,
    x2: 136.547,
    y2: 114.13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ea6100",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ea6100",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M96 56l34.65 60-38.88 68H184V56z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DB4437",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 29.337,
    y1: 75.021,
    x2: 81.837,
    y2: 44.354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a52714",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#a52714",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M21.97 8v108h39.39L96 56h88V8z"
  })))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 668.176,
    cy: 55.948,
    r: 84.078,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "url(#l)",
    d: "M96 56v20.95L174.4 56z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M21.97 8v40.34L61.36 116 96 56h88V8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F9D58",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    gradientUnits: "userSpaceOnUse",
    x1: 110.872,
    y1: 164.495,
    x2: 52.538,
    y2: 130.329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#055524",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#055524",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M8 184h83.77l38.88-38.88V116H61.36L8 24.48z"
  })))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 597.875,
    cy: 48.52,
    r: 78.044,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e2723",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e2723",
    stopOpacity: 0
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "url(#p)",
    d: "M21.97 48.45l57.25 57.24L61.36 116z"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 671.844,
    cy: 96.138,
    r: 87.87,
    gradientTransform: "translate(-576)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#263238",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#263238",
    stopOpacity: 0
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#b)",
    fill: "url(#q)",
    d: "M91.83 183.89l20.96-78.2L130.65 116z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F1F1",
    cx: 96,
    cy: 96,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#4285F4",
    cx: 96,
    cy: 96,
    r: 32
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.2,
    d: "M96 55c-22.09 0-40 17.91-40 40v1c0-22.09 17.91-40 40-40h88v-1H96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.1,
    d: "M130.6 116c-6.92 11.94-19.81 20-34.6 20-14.8 0-27.69-8.06-34.61-20h-.04L8 24.48v1L61.36 117h.04c6.92 11.94 19.81 20 34.61 20 14.79 0 27.68-8.05 34.6-20h.05v-1h-.06z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E2723",
    d: "M97 56c-.17 0-.33.02-.5.03C118.36 56.3 136 74.08 136 96s-17.64 39.7-39.5 39.97c.17 0 .33.03.5.03 22.09 0 40-17.91 40-40s-17.91-40-40-40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M131 117.33c3.4-5.88 5.37-12.68 5.37-19.96 0-4.22-.66-8.28-1.87-12.09.95 3.42 1.5 7.01 1.5 10.73 0 7.28-1.97 14.08-5.37 19.96l.02.04-38.88 68h1.16l38.09-66.64-.02-.04z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.2,
    d: "M96 9c48.43 0 87.72 39.13 87.99 87.5 0-.17.01-.33.01-.5 0-48.6-39.4-88-88-88S8 47.4 8 96c0 .17.01.33.01.5C8.28 48.13 47.57 9 96 9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E2723",
    fillOpacity: 0.15,
    d: "M96 183c48.43 0 87.72-39.13 87.99-87.5 0 .17.01.33.01.5 0 48.6-39.4 88-88 88S8 144.6 8 96c0-.17.01-.33.01-.5C8.28 143.87 47.57 183 96 183z"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 34.286,
    cy: 32.014,
    r: 176.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#r)",
    cx: 96,
    cy: 96,
    r: 88
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h192v192H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChromeLogo);
export default __webpack_public_path__ + "static/media/chrome-logo.d5ba6a0739c8da44b635262f6c8ebeca.svg";
export { ForwardRef as ReactComponent };